(function () {
    'use strict';

    angular.module("imApp").factory("ttWebPageMenuService", ['$q', 'dataTask0To99Service', 'ttWebPageMenuEditorService', function ($q, dataTask0To99Service, ttWebPageMenuEditorService) {
        var service = {
            load: function (webpageName, editMode) {
                // BJS 20260310 - Modified to call downgraded angular service
                return $q.when(dataTask0To99Service.dt53({
                    webpageName: webpageName,
                    editMode: !!editMode
                }));
            },

            delete: ttWebPageMenuEditorService.delete
        };

        return service;
    }]);
})();
